import { createAction, props } from '@ngrx/store';
import { GetRuleExpressionsInHierarchyRequestDto } from 'src/app/compliance/api/models/get-rule-expressions-in-hierarchy-request-dto.model';
import { GroupedWinningRuleset } from 'src/app/compliance/api/models/grouped-winning-ruleset.model';

export const loadAutomatchGroupedWinningRuleset = createAction(
    '[Automatch] Load Grouped Winning Ruleset',
    props<{ getRuleExpressionsInHierarchyRequestDto: GetRuleExpressionsInHierarchyRequestDto }>()
);

export const loadAutomatchGroupedWinningRulesetSuccess = createAction(
    '[Automatch] Load Grouped Winning Ruleset Success',
    props<{ groupedWinningRuleset: GroupedWinningRuleset }>()
);

export const loadAutomatchGroupedWinningRulesetFailure = createAction(
    '[Automatch] Load Grouped Winning Ruleset Failure',
    props<{ error: any }>()
);

export const clearAutomatchGroupedWinningRuleset = createAction('[Automatch] Clear Grouped Winning Ruleset');
